import React, { useState, useEffect } from "react";
import api from "../api/axios";
import { resolveImageSrc } from "../api/axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";

import { Editor } from '@tinymce/tinymce-react';



export default function ItemForm({ item, type, onSubmit, onCancel }) {
    const [itemsData, setItemsData] = useState([]);

    // Initialiser le state à partir de item.items
    useEffect(() => {
        if (!item) return;

        if (type.has_multiple) {
            setItemsData(item.items.map(i => ({
                id: i.id || "",
                title: i.title || "",
                picture1: i.picture1 || "",
                alt_picture1: i.alt_picture1 || "",
                picture2: i.picture2 || "",
                alt_picture2: i.alt_picture2 || "",
                description: i.description || "",
                link: i.link || "",
                order_position: i.order_position || ""
            })));
        } else {
            const i = item.items[0] || {};
            setItemsData([{
                id: i.id || "",
                title: i.title || "",
                picture1: i.picture1 || "",
                alt_picture1: i.alt_picture1 || "",
                picture2: i.picture2 || "",
                alt_picture2: i.alt_picture2 || "",
                description: i.description || "",
                link: i.link || ""
            }]);
        }
    }, [item, type]);

    const handleFileChange = (index, field, file) => {
        const newItems = [...itemsData];
        newItems[index][`${field}File`] = file;
        newItems[index][field] = URL.createObjectURL(file);
        setItemsData(newItems);
    };

    const handleChange = (index, field, value) => {
        const newItems = [...itemsData];
        newItems[index][field] = value;
        setItemsData(newItems);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(itemsData);
    };

    const deleteItem = async (itemId, index) => {
        if (!window.confirm("Voulez-vous vraiment faire cette suppression ?")) return;

        try {
            await api.delete(`/api/items/${itemId}`);

            const newItems = itemsData.filter((_, idx) => idx !== index);
            setItemsData(newItems);

            if (onSubmit) {
                await onSubmit(newItems);
            }

            alert("Supprimé avec succès !");
        } catch (err) {
            console.error(err.response?.data || err);
            alert("Erreur lors de la suppression.");
        }
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4 max-h-[80vh] overflow-y-auto">
            {itemsData.map((i, idx) => (
                <div key={idx} className="border p-4 rounded mb-4">
                    {type.has_multiple !== 0 && (
                        <div className="flex justify-between">
                            <p className="px-4 py-2 my-1 rounded bg-gray-700 text-gray-100">{i.order_position}</p>
                            {idx === itemsData.length - 1
                                ?
                                <div>
                                    <button
                                        type="button"
                                        onClick={() => deleteItem(i.id, idx)}
                                        className="px-4 py-2 rounded bg-red-500 text-red-100"
                                    >
                                        <FontAwesomeIcon icon={faTrashCan} />
                                    </button>
                                </div>
                                :
                                null
                            }
                        </div>
                    )}
                    {type.has_title !== 0 && (
                        <div>
                            <label className="block font-semibold">Titre</label>
                            <input
                                value={i.title}
                                onChange={(e) => handleChange(idx, "title", e.target.value)}
                                className="w-full border p-2 rounded"
                            />
                        </div>
                    )}
                    {type.has_description !== 0 && (
                        <div>
                            <label className="block font-semibold mb-1">Description</label>
                            <Editor
                                apiKey="r05d3k4e274iui1e8a3ckukco0si8g7gwtpyqxmmjl4eqq16"
                                value={i.description}
                                init={{
                                    height: 400,
                                    menubar: false,
                                    language: "fr_FR",
                                    language_url: 'https://cdn.tiny.cloud/1/r05d3k4e274iui1e8a3ckukco0si8g7gwtpyqxmmjl4eqq16/tinymce/6/langs/fr_FR.js',
                                    plugins: 'advlist autolink lists link image charmap preview anchor searchreplace visualblocks code fullscreen insertdatetime media table help wordcount',
                                    toolbar: `undo redo | formatselect | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat`,
                                    paste_data_images: false,
                                    automatic_uploads: false,
                                    images_upload_url: "",
                                    setup: function (editor) {
                                        editor.on('drop', function (e) {
                                            e.preventDefault();
                                            alert('Le glisser-déposer d’images est désactivé !');
                                        });
                                    }
                                }}
                                onEditorChange={(content) => handleChange(idx, "description", content)}
                            />
                        </div>
                    )}
                    {type.has_link !== 0 && (
                        <div>
                            {i.link?.toLowerCase().includes("youtube") && i.link?.toLowerCase().includes("embed") ? (
                                <iframe
                                    className="w-full h-64 rounded-lg"
                                    src={i.link}
                                    title={item.title || "Vidéo"}
                                    allow="clipboard-write; encrypted-media"
                                    allowFullScreen
                                ></iframe>
                            ) : null}
                            <label className="block font-semibold">Lien</label>
                            <input
                                value={i.link}
                                onChange={(e) => handleChange(idx, "link", e.target.value)}
                                className="w-full border p-2 rounded"
                            />
                        </div>
                    )}
                    {type.has_picture1 !== 0 && (
                        <div>
                            <label className="inline-block w-full font-semibold mb-1 text-center mx-auto">Image</label>
                            <div className="w-full flex justify-center flex-row mb-2 ">
                                {/* Prévisualisation de l'image */}
                                {(i.picture1File || i.picture1) && (
                                    <img
                                        src={
                                            i.picture1File
                                                ? URL.createObjectURL(i.picture1File)
                                                : resolveImageSrc(i.picture1)
                                        }
                                        alt="Aperçu"
                                        className="max-h-48 rounded border"
                                    />
                                )}

                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (file) handleFileChange(idx, "picture1", file);
                                    }}
                                />
                            </div>
                        </div>
                    )}
                    {type.has_alt_picture1 !== 0 && (
                        <div>
                            <label className="block font-semibold">(Description d'accessibilité) Image</label>
                            <input
                                value={i.alt_picture1}
                                onChange={(e) => handleChange(idx, "alt_picture1", e.target.value)}
                                className="w-full border p-2 rounded"
                            />
                        </div>
                    )}
                    {type.has_picture2 !== 0 && (
                        <div>
                            <label className="inline-block w-full font-semibold mb-1 text-center mx-auto">Image</label>
                            <div className="w-full flex justify-center flex-row mb-2 ">
                                {/* Prévisualisation de l'image */}
                                {(i.picture2File || i.picture2) && (
                                    <img
                                        src={
                                            i.picture2File
                                                ? URL.createObjectURL(i.picture2File)
                                                : resolveImageSrc(i.picture2)
                                        }
                                        alt="Aperçu"
                                        className="max-h-48 rounded border"
                                    />
                                )}
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (file) handleFileChange(idx, "picture2", file);
                                    }}
                                />
                            </div>
                        </div>
                    )}
                    {type.has_alt_picture2 !== 0 && (
                        <div>
                            <label className="block font-semibold">(Description d'accessibilité) 2ème Image</label>
                            <input
                                value={i.alt_picture1}
                                onChange={(e) => handleChange(idx, "alt_picture1", e.target.value)}
                                className="w-full border p-2 rounded"
                            />
                        </div>
                    )}
                </div>
            ))}

            <div className="flex justify-end gap-2 mt-4">
                <button
                    type="button"
                    onClick={onCancel}
                    className="px-4 py-2 rounded bg-gray-200"
                >
                    Annuler
                </button>
                <button
                    type="submit"
                    className="px-4 py-2 rounded bg-blue-500 text-white"
                >
                    Enregistrer
                </button>
            </div>
        </form>
    );
}
